/**
 * @typedef {enum} MEDIA_SEGMENT_EDIT_TYPE
 */
export const MEDIA_SEGMENT_EDIT_TYPE = {
  LETTERBOX: 'LETTERBOX',
  SPLIT_VERTICAL_2: 'SPLIT_VERTICAL_2',
  SPLIT_VERTICAL_3: 'SPLIT_VERTICAL_3',
  STATIC_CROP: 'STATIC_CROP',
};

export const VALID_MEDIA_SEGMENT_EDIT_TYPES = Object.keys(
  MEDIA_SEGMENT_EDIT_TYPE,
);
